<div [ngClass]="{ 'is-hidden': !isVisible }">
    <header class="bciti-dialog__header">
        <div class="bciti-dialog__title">
            {{ "pages.user-cards.family.create.heading" | translate }}
        </div>
        <button class="bciti-dialog__close-button" (click)="closeDialog()">
            <span  class="icon icon-close"></span>
        </button>
    </header>
    <div class="bciti-dialog__content">
        <div class="spinner-wrapper">
            <mat-progress-spinner *ngIf="formLoading" mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
        <form [formGroup]="addFamilyMemberForm" id="idAddFamilyMemberForm" *ngIf="!formLoading && viewMode === 'edit'">
            <div class="form-section-title">{{ 'pages.user-cards.family.create.subtitle' | translate }}</div>
            <div class="form-group" class="mb-20">
                <app-form-user-card-profile-picture
                    [disabled]="readOnly"
                    label="{{ avatar.value !== '' ? ('pages.user-cards.family.create.avatar.labelSelected' | translate) : ('pages.user-cards.family.create.avatar.label' | translate) }}"
                    formControlName="avatar"
                    data-cy="avatar"
                    [imgPlaceholder]="false"
                    [disableMessages]="avatar.touched && avatar.hasError('required') ? false : true"
                >
                    <app-form-error *ngIf="avatar.touched && avatar.hasError('required')">
                      {{'pages.user-cards.family.common.errors.invalidProfilePicture' | translate }}
                    </app-form-error>
                </app-form-user-card-profile-picture>
                <div class="avatar-upload-instructions" *ngIf="!avatar.value">
                    {{ 'pages.user-cards.family.create.avatar.instructions' | translate }}
                </div>
            </div>
            <div class="form-group">
                <app-form-input
                    label="{{ 'common.fields.firstName' | translate }}"
                    formControlName="firstName"
                    [messages]="firstName.touched && firstName.hasError('required') ? false : true"
                >
                    <app-form-error *ngIf="firstName.touched && firstName.hasError('required')">
                        {{ "common.errors.invalidFirstName" | translate }}
                    </app-form-error>
                </app-form-input>
            </div>
            <div class="form-group">
                <app-form-input
                    label="{{ 'common.fields.lastName' | translate }}"
                    formControlName="lastName"
                    [messages]="lastName.touched && lastName.hasError('required') ? false : true"
                >
                    <app-form-error *ngIf="lastName.touched && lastName.hasError('required')">
                        {{ "common.errors.invalidLastName" | translate }}
                    </app-form-error>
                </app-form-input>
            </div>
            <div
                class="form-group"
                [ngClass]="{
                    'select-invalid': gender.touched && gender.hasError('required'),
                    'select-valid': gender.touched && gender.valid
                }"
            >
                <app-form-select-user-cards
                    label="{{ 'pages.user-cards.family.create.gender.label' | translate }}"
                    placeholder="{{ 'pages.user-cards.family.create.gender.placeholder' | translate }}"
                    [class.ng-invalid]="gender?.invalid"
                    [useOptionAll]="false"
                    [selected]="selectedGender"
                    [options]="genderOptions"
                    (selectChange)="genderChange($event)"
                >
                </app-form-select-user-cards>
                <div class="messages" *ngIf="gender.touched && gender.hasError('required')">
                    <div class="error">
                      <p>{{ "pages.user-cards.family.error.invalidGender" | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <app-form-datepicker
                    type="tel" 
                    label="{{ 'pages.user-cards.family.create.birthdate.label' | translate }}"
                    placeholder="{{ 'pages.user-cards.family.create.birthdate.placeholder' | translate }}"
                    type="tel"
                    [max]="maxDate"
                    formControlName="birthDate"
                    [showMessages]="birthDate.touched && birthDate.hasError('required') ? true : false"
                >
                    <app-form-error *ngIf="birthDate.touched && birthDate.hasError('required')">
                        {{'pages.user-cards.family.create.birthdate.invalidBirthDate' | translate }}
                    </app-form-error>
                </app-form-datepicker>
            </div>
            <div
                class="form-group"
                [ngClass]="{
                    'select-invalid': targetLink.touched && targetLink.hasError('required'),
                    'select-valid': targetLink.touched && targetLink.valid
                }"
            >
                <app-form-select-user-cards
                    label="{{ 'pages.user-cards.family.create.link.label' | translate }}"
                    placeholder="{{ 'pages.user-cards.family.create.link.placeholder' | translate }}"
                    [class.ng-invalid]="targetLink?.invalid"
                    [useOptionAll]="false"
                    [selected]="selectedLink"
                    [options]="familyLinks"
                    (selectChange)="linkChange($event)"
                >
                </app-form-select-user-cards>
                <div class="messages" *ngIf="targetLink.touched && targetLink.hasError('required')">
                    <div class="error">
                      <p>{{ "pages.user-cards.family.error.invalidLink" | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <app-form-input
                    type="phone"
                    appPhoneMask
                    [label]="phoneLabel"
                    placeholder="{{ 'pages.user-cards.family.create.phone.placeholder' | translate }}"
                    formControlName="phone"
                    [messages]="phone.touched && (phone.hasError('minlength') || phone.hasError('maxlength') || phone.hasError('required')) ? false : true"
                >
                    <app-form-error *ngIf="phone.touched && (phone.hasError('minlength') || phone.hasError('maxlength'))">
                        {{'pages.user-cards.family.create.phone.invalidPhone' | translate }}
                    </app-form-error>
                    <app-form-error *ngIf="phone.touched && phone.hasError('required')">
                        {{ 'pages.user-cards.family.common.errors.required' | translate }}
                    </app-form-error>
                </app-form-input>
            </div>
            <div class="form-group">
                <app-form-input
                    label="{{ 'pages.user-cards.family.create.email.label' | translate }}"
                    placeholder="{{ 'pages.user-cards.family.create.email.placeholder' | translate }}"
                    formControlName="email"
                    [messages]="email.touched && (email.hasError('sameEmail') || email.hasError('email')) ? false : true"
                >
                    <app-form-error *ngIf="email.touched && email.hasError('email')">
                        {{ "common.errors.invalidEmail" | translate }}
                    </app-form-error>
                    <app-form-error *ngIf="email.touched && email.hasError('sameEmail')">
                        {{ "pages.user-cards.family.error.familySameEmail" | translate }}
                    </app-form-error>
                </app-form-input>
            </div>
            <div class="form-section-title mt-30">{{ "pages.user-cards.family.create.address.title" | translate }}</div>
            <div class="form-group">
                <app-address-card
                    (toggleCurrentDialogVisibility)="toggleDialogVisibility()"
                    (selectedAddressChange)="addressChange($event)"
                    formControlName="address"
                    [disableMessages]="address.touched && address.hasError('required') ? false : true"
                >
                    <app-form-error *ngIf="address.touched && address.hasError('required')">
                        {{ "pages.user-cards.family.error.invalidAddress" | translate }}
                    </app-form-error>
                </app-address-card>
            </div>
        </form>
        <div *ngIf="viewMode === 'review'">
            <div class="form-section-title show-on-mobile">
                {{ "pages.user-cards.family.create.review.title" | translate }}
            </div>
            <div class="review">
                <div class="review__header">
                    <div class="review__avatar">
                        <img
                            *ngIf="avatar.value"
                            [src]="avatar.value"
                            alt="{{ 'pages.user-cards.family.create.avatar.alt' | translate }}"
                        />
                    </div>
                    <button class="review__edit" (click)="switchEditMode()">{{ 'pages.user-cards.common.button.edit' | translate }}</button>
                </div>
                <div class="review__row review__row--2cols">
                    <div>
                        <div class="review__label">{{ 'common.fields.firstName' | translate }}</div>
                        <div class="review__value"><strong>{{ firstName.value }}</strong></div>
                    </div>
                    <div>
                        <div class="review__label">{{ 'common.fields.lastName' | translate }}</div>
                        <div class="review__value"><strong>{{ lastName.value }}</strong></div>
                    </div>
                </div>
                <div class="review__row review__row--2cols">
                    <div>
                        <div class="review__label">{{ 'pages.user-cards.family.create.gender.label' | translate }}</div>
                        <div class="review__value">{{ gender.value }}</div>
                    </div>
                    <div>
                        <div class="review__label">{{ 'pages.user-cards.family.create.birthdate.label' | translate }}</div>
                        <div class="review__value">{{ birthDate.value | date: 'd MMM yyyy' }}</div>
                    </div>
                </div>
                <div class="review__row">
                    <div>
                        <div class="review__label">{{ 'pages.user-cards.family.create.address.title' | translate }}</div>
                        <div class="review__value">{{ formattedAddress }}</div>
                    </div>
                </div>
                <div class="review__row" *ngIf="addFamilyMemberForm.value.phone">
                    <div>
                        <div class="review__label">{{ 'pages.user-cards.family.create.phone.title' | translate }}</div>
                        <div class="review__value">{{ phone.value }}</div>
                    </div>
                </div>
                <div class="review__row" *ngIf="addFamilyMemberForm.value.email">
                    <div>
                        <div class="review__label">{{ 'pages.user-cards.family.create.email.title' | translate }}</div>
                        <div class="review__value">{{ email.value }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="bciti-dialog__footer" *ngIf="viewMode === 'edit'">
        <button class="bciti-button bciti-button--lightblue-inversed" (click)="closeDialog()">
            <span>{{ "pages.user-cards.common.button.cancel" | translate }}</span>
        </button>
        <button
            class="bciti-button bciti-button--blue"
            (click)="switchReviewMode()"
        >
            <span>{{ 'pages.user-cards.common.button.next' | translate }}</span>
        </button>
    </footer>
    <footer class="bciti-dialog__footer" *ngIf="viewMode === 'review'">
        <button class="bciti-button bciti-button--lightblue-inversed" (click)="switchEditMode()">
            <span>{{ "pages.user-cards.common.button.back" | translate }}</span>
        </button>
        <button
            class="bciti-button"
            [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'" 
            [disabled]="processingSubmit"
            (click)="submit()"
        >
            <span *ngIf="!processingSubmit">{{ 'pages.user-cards.common.button.confirm' | translate }}</span>
            <mat-spinner diameter="20" *ngIf="processingSubmit"></mat-spinner>
        </button>
    </footer>
</div>
